// @flow
import type { Config, PlaneEntity, Plane } from '../../types';
import useNow from '../../hooks/useNow';
import { isActive } from '../../utils/targetUtils';


export type Props = $ReadOnly<{
    sessionConfig: $PropertyType<Config, 'session'>,
    icao: string,
    entity: PlaneEntity,
    plane: Plane,

    endSession: (icao: string) => void
}>;

function SyncPlane({ sessionConfig, icao, entity, plane, endSession }: Props) {
    useNow();

    if(typeof entity.sessionStart !== 'undefined' && !isActive(plane.TimeOfTrackInformation, sessionConfig)) {
        endSession(icao);
    }

    return null;
}

export default SyncPlane;